import { NgModule, ModuleWithProviders, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ContentModule } from './content/content.module';
import { FooterModule } from './footer/footer.module';
import { HeaderModule } from './header/header.module';
import { SidebarLeftModule } from './sidebar-left/sidebar-left.module';
import { SidebarRightModule } from './sidebar-right/sidebar-right.module';
import { WrapperModule } from './wrapper/wrapper.module';

import { LayoutStore } from './layout.store';
import { LayoutState } from './layout.state';
import { layoutProvider } from './layout.provider';

import { RoutingService } from '../routing.service';
import { WrapperService } from './wrapper/wrapper.service';
import { SidebarRightService } from './sidebar-right/sidebar-right.service';
import { HeaderService } from './header/header.service';
import { FooterService } from './footer/footer.service';
export class LayoutModule {
/**
 * \@method constructor
 * @param {?} parentModule
 */
constructor(  parentModule: LayoutModule) {
    if(parentModule) {
      throw new Error('LayoutModule is already loaded. Import it in the AppModule only!');
    }
  }
/**
 * [forRoot description]
 * \@method forRoot
 * @param {?} layoutConfig
 * @return {?}
 */
static forRoot(layoutConfig: LayoutState): ModuleWithProviders {
    return {
      ngModule: LayoutModule,
      providers: layoutProvider(layoutConfig)
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [CommonModule, RouterModule],
  exports: [ContentModule, FooterModule, HeaderModule, SidebarLeftModule, SidebarRightModule, WrapperModule],
  providers: [RoutingService, WrapperService, SidebarRightService, HeaderService, FooterService]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: LayoutModule, decorators: [{ type: Optional }, { type: SkipSelf }, ]},
];
}

function LayoutModule_tsickle_Closure_declarations() {
/** @type {?} */
LayoutModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
LayoutModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
